import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Translation } from 'react-i18next';

import { Link } from 'react-router-dom';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import FixedNotification from 'components/common/FixedNotification';
import onClickOutside from 'react-onclickoutside';

import { downloadQrCode } from 'components/dashboard/appearance-content/AvatarQrCodeGenerator';

import './UsernamePopup.css';

class UsernamePopup extends Component {
  state = {
    showPopup: false,
    copyUrl: false,
    copyUrlShort: false,
  };

  static propTypes = {
    me: PropTypes.object,
  };
  static defaultProps = {
    me: null,
  };

  handleClickOutside = () => {
    this.setState({ showPopup: false });
  };

  handleActionClick = () => {
    this.setState({ showPopup: false });
  };

  handleQRCodeDownload = () => {
    downloadQrCode(this.props.me.qr_code_image);
    this.setState({ showPopup: false });
  };

  render() {
    const { me } = this.props;
    const { showPopup, copyUrl, copyUrlShort } = this.state;

    return (
      <Translation>
        {(t) => (
          <div className="username-popup__component">
            <div
              className="breadcramb-icon"
              onClick={() => { this.setState({ showPopup: !showPopup }); }}
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="56" height="50" viewBox="0 0 56 50"><path d="M33.128 41.786v-6.243h22.873v6.243H33.128zM46.934 8.2h9.067v6.243h-9.067V8.2zM30.758 22.645c-5.122 0-9.599-3.357-10.997-8.202H-.009V8.2h19.77c1.398-4.845 5.875-8.202 10.997-8.202 6.307 0 11.436 5.079 11.436 11.324 0 6.244-5.129 11.323-11.436 11.323zm0-16.405c-2.829 0-5.133 2.28-5.133 5.082 0 2.8 2.304 5.081 5.133 5.081 2.828 0 5.131-2.281 5.131-5.081 0-2.802-2.303-5.082-5.131-5.082zM16.95 27.339c6.307 0 11.437 5.08 11.437 11.326 0 6.245-5.13 11.323-11.437 11.323-5.12 0-9.599-3.356-10.997-8.202H-.009v-6.243h5.962c1.398-4.846 5.877-8.204 10.997-8.204zm0 16.407c2.829 0 5.132-2.281 5.132-5.081 0-2.802-2.303-5.082-5.132-5.082-2.829 0-5.132 2.28-5.132 5.082 0 2.8 2.303 5.081 5.132 5.081z" fill="#878CAC"/></svg>
            </div>
    
            {showPopup &&
              <div className="username-popup-content">
                <CopyToClipboard
                    text={me.url}
                    onCopy={() => {
                      this.setState({ copyUrl: true });
                    }}
                  >
                    <div className="action-item" onClick={this.handleActionClick}>
                      <div className="icon full-link" />
                      <div className="text">{t("Copy Full Link")}</div>
                    </div>
                  </CopyToClipboard>
    
                  <CopyToClipboard
                    text={me.short_url}
                    onCopy={() => {
                      this.setState({ copyUrlShort: true });
                    }}
                  >
                    <div className="action-item" onClick={this.handleActionClick}>
                      <div className="icon short-link" />
                      <div className="text">{t("Copy Short Link")}</div>
                    </div>
                  </CopyToClipboard>
    
                  {me && me.qr_code_image &&
                    <div className="action-item" onClick={this.handleQRCodeDownload}>
                      <div className="icon qr-code" />
                      <div className="text">{t("Download QR Code")}</div>
                    </div>
                  }
    
    
                <div className="divider" />
    
                <Link
                  className="action-item"
                  to="/appearance?focus=username"
                  onClick={this.handleActionClick}
                >
                  <div className="icon edit-username" />
                  <div className="text">{t("Change Username")}</div>
                </Link>
    
              </div>
            }
    
            {copyUrl === true &&
              <FixedNotification
                onFadeComplete={() => {
                  this.setState({ copyUrl: false });
                }}
              >
                {t("Link has been copied: paste it anywhere!")}
              </FixedNotification>
            }
    
            {copyUrlShort === true &&
              <FixedNotification
                onFadeComplete={() => {
                  this.setState({ copyUrlShort: false });
                }}
              >
                {t("Short link has been copied: paste it anywhere!")}
              </FixedNotification>
            }
          </div>
        )}
      </Translation>
    );
  }
}

export default onClickOutside(UsernamePopup);
